import { Box, Flex } from '@chakra-ui/react';
import { ErrorMessage, Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';

import {
  handleActionStepNext,
  resetSingleIndicatorValue,
  setMultipleIndicatorsType,
} from 'redux/DataImportSlice';
import IndicatorRow from 'components/Icons/IndicatorMultipleTableImage/IndicatorRow';
import IndicatorColumn from 'components/Icons/IndicatorMultipleTableImage/IndicatorColumn';

import ActionStepFooter from '../../ActionStepFooter';
import {
  FieldError,
  FieldLabel,
  RadioDot,
  StepFooterRow,
  optionCardStyle,
} from '../../actionStepUi';

const validationSchema = yup.object().shape({
  multipleIndicatorsType: yup
    .string()
    .oneOf(['row', 'column'], 'Please select atleast one')
    .required('select time period'),
});

interface Properties {
  getFormValue: any;
}

const MultipleIndicators = ({ getFormValue }: Properties) => {
  const dispatch: any = useDispatch();

  const handleSubmit = (form: any, setSubmitting: (data: boolean) => void) => {
    dispatch(setMultipleIndicatorsType(form)).then(() => {
      dispatch(resetSingleIndicatorValue());
      setSubmitting(false);
      dispatch(handleActionStepNext());
    });
  };
  return (
    <Formik
      initialValues={{
        multipleIndicatorsType: '' || `${getFormValue.multipleIndicatorsType}`,
      }}
      validationSchema={validationSchema}
      onSubmit={(form, { setSubmitting }) => handleSubmit(form, setSubmitting)}
      enableReinitialize={true}
    >
      {({ values, isSubmitting, setFieldValue }: any) => (
        <Form style={{ width: '100%' }}>
          <Box mt={4}>
            <FieldLabel>Are your indicators in rows or columns?</FieldLabel>
            <Flex direction='column' gap={2}>
              {[
                { value: 'row', label: 'Select rows', illustration: <IndicatorRow /> },
                { value: 'column', label: 'Select columns', illustration: <IndicatorColumn /> },
              ].map((option) => {
                const isSelected = values.multipleIndicatorsType === option.value;
                return (
                  <Flex
                    key={option.value}
                    as='button'
                    type='button'
                    role='radio'
                    aria-checked={isSelected}
                    {...optionCardStyle(isSelected)}
                    direction='column'
                    alignItems='flex-start'
                    onClick={() => setFieldValue('multipleIndicatorsType', option.value)}
                  >
                    <Flex alignItems='center' gap={2}>
                      <RadioDot isSelected={isSelected} />
                      {option.label}
                    </Flex>
                    <Box w='100%' sx={{ svg: { width: '100%', height: 'auto' } }}>
                      {option.illustration}
                    </Box>
                  </Flex>
                );
              })}
            </Flex>
            <ErrorMessage name='multipleIndicatorsType' component={FieldError} />
          </Box>

          <StepFooterRow>
            <ActionStepFooter
              nextButtonName='Continue'
              prevButtonName='Previous'
              isSubmitting={isSubmitting}
            />
          </StepFooterRow>
        </Form>
      )}
    </Formik>
  );
};

export default MultipleIndicators;
